/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.605 4.2504c-.3947-.546-.5143-1.229-.3589-1.8581V2c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75v.4943c-3.59.8942-6.25 4.1387-6.25 8.0057v8H.75a.75.75 0 0 0 0 1.5h4.996c0 2.0711 1.679 3.75 3.75 3.75 2.0712 0 3.7501-1.6789 3.7501-3.75H19a.75.75 0 0 0 0-1.5h-.7539v-3.628a2.2467 2.2467 0 0 1-.75.128c-1.1201 0-2.049-.8184-2.2213-1.8899a6.461 6.461 0 0 1-.5283-.219c-.8795.6359-2.1152.5578-2.9073-.2342-.792-.7921-.8701-2.0278-.2342-2.9073a6.4635 6.4635 0 0 1-.219-.5283C10.3145 9.049 9.496 8.1201 9.496 7c0-1.12.8185-2.049 1.89-2.2213.0654-.18.1386-.3562.219-.5283ZM11.7461 20c0 1.2426-1.0074 2.25-2.25 2.25s-2.25-1.0074-2.25-2.25h4.5Zm6.5-8.0559a4.9725 4.9725 0 0 0 2.2154-.918l.5701.5701a.75.75 0 0 0 1.0607-1.0607l-.5701-.57a4.9751 4.9751 0 0 0 .918-2.2155h.8059a.75.75 0 0 0 0-1.5h-.8059a4.9751 4.9751 0 0 0-.918-2.2154l.5701-.5701a.75.75 0 1 0-1.0607-1.0607l-.5701.5701a4.9736 4.9736 0 0 0-2.2154-.918V1.25a.75.75 0 0 0-1.5 0v.8059a4.9736 4.9736 0 0 0-2.2154.918l-.5701-.5701a.75.75 0 0 0-1.0607 1.0607l.5701.57a4.9728 4.9728 0 0 0-.918 2.2155h-.8059a.75.75 0 0 0 0 1.5h.8059a4.9728 4.9728 0 0 0 .918 2.2154l-.5701.5701a.75.75 0 0 0 1.0607 1.0607l.5701-.5701a4.9725 4.9725 0 0 0 2.2154.918v.8059a.75.75 0 0 0 1.5 0v-.8059Zm-.75-1.4441c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5-3.5 1.567-3.5 3.5 1.567 3.5 3.5 3.5Zm0-2.5c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z"
    clipRule="evenodd"
  />,
  'MenuAlertConfigurationFilled'
);
